/// <amd-module name="SuiteCommerce.GridOrder.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Configuration", ["require", "exports", "SuiteCommerce.GridOrder.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GridOrderConfiguration = /** @class */ (function (_super) {
        __extends(GridOrderConfiguration, _super);
        function GridOrderConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(GridOrderConfiguration, "title", {
            get: function () {
                return this.get('gridOrder.title');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "quantityWarningMessage", {
            get: function () {
                return this.get('gridOrder.quantityWarningMessage');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "subtotalPriceLabel", {
            get: function () {
                return this.get('gridOrder.subtotalPriceLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "addToCartButtonLabel", {
            get: function () {
                return this.get('gridOrder.addToCartButtonLabel') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "quantitySummaryLabel", {
            get: function () {
                return this.get('gridOrder.quantitySummaryLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "viewCartButtonLabel", {
            get: function () {
                return this.get('gridOrder.viewCartButtonLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "continueShoppingButtonLabel", {
            get: function () {
                return this.get('gridOrder.continueShoppingButtonLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "confirmationText", {
            get: function () {
                return this.get('gridOrder.confirmationText') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "quantityPricingLabel", {
            get: function () {
                return this.get('gridOrder.quantityPricingLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "tableDisplayOptions", {
            get: function () {
                return this.get('gridOrder.tableDisplayOptions');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "combinationNotAvailable", {
            get: function () {
                return this.get('gridOrder.combinationNotAvailable');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "stockNotificationsLabel", {
            get: function () {
                return this.get('gridOrder.stockNotificationsLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "matrixDimensionArrangements", {
            get: function () {
                return this.get('gridOrder.matrixDimensionArrangement');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "isActivatedForAllMatrixItems", {
            get: function () {
                return this.get('gridOrder.activateForAllMatrixItems');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "minimumQuantityHint", {
            get: function () {
                return this.get('gridOrder.minimumQuantityHint') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "maximumQuantityHint", {
            get: function () {
                return this.get('gridOrder.maximumQuantityHint') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "inventoryLabel", {
            get: function () {
                return this.get('gridOrder.inventoryLabel') || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(GridOrderConfiguration, "isQuantityPricingEnabled", {
            get: function () {
                return this.get('siteSettings.quantitypricing');
            },
            enumerable: true,
            configurable: true
        });
        return GridOrderConfiguration;
    }(Configuration_1.Configuration));
    exports.GridOrderConfiguration = GridOrderConfiguration;
});
